import { render } from "./works.html?vue&type=template&id=81dbac78&scoped=true&ts=true"
import script from "./works.ts?vue&type=script&lang=ts"
export * from "./works.ts?vue&type=script&lang=ts"

import "./works.scss?vue&type=style&index=0&id=81dbac78&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81dbac78"]])

export default __exports__